import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Navigation } from "./components/Navigation";
import { Hero } from "./components/Hero";
import { About } from "./components/About";
import { ElderlyAssist } from "./components/ElderlyAssist";
import { FocusAreas } from "./components/FocusAreas";
import { Impact } from "./components/Impact";
import { Team } from "./components/Team";
import { Contact } from "./components/Contact";
import { Compliance } from "./components/Compliance";
import { Footer } from "./components/Footer";

const Home = () => {
  return (
    <main className="min-h-screen bg-sentivo-bg" data-testid="home-page">
      <Navigation />
      <Hero />
      <About />
      <ElderlyAssist />
      <FocusAreas />
      <Impact />
      <Team />
      <Contact />
      <Compliance />
      <Footer />
    </main>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#1A211D",
            color: "#FAF9F6",
            border: "1px solid #2C3E35",
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
